import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { ClickConsigmentCTA } from '@app/+product/store/actions/product.action';

/**
 * On product pages, when user click on consigment cta
 */
const events = getEvents((action: ClickConsigmentCTA) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'concierge_service',
      position: action.position,
      env_template: 'product'
    }
  },
  {
    type: 'ClickConsigmentCTA - productPage',
    container: TagContainer.Media,
    eventCategory: 'product',
    eventAction: 'concierge_service',
    eventLabel: 'profil : product_product_details'
  }
]);

export default events;
